import { UserSearchParams, UserSearchFacets } from 'utils/wemble-api.generated';

// Active filter types — discriminated union, extensible
export type ActiveFilter =
  | { type: 'group'; groupIds: string[]; names: string[] }
  | { type: 'office'; officeNames: string[] }
  | { type: 'title'; titles: string[] }
  | { type: 'competence'; competenceId: string; minLevel?: number }
  | { type: 'experience'; dimension: string; keys: string[]; labels: string[]; minHours?: number };

// Internal filter state
export interface FilterState {
  teams: string[];          // office IDs (each = one group+office pair), or ['__all__']
  advancedFilters: ActiveFilter[];
  competenceOperator: 'and' | 'or';
  searchTerm: string;       // frontend-only
}

// Color scheme per filter type
export const FILTER_COLORS: Record<string, { bg: string; text: string }> = {
  group: { bg: '#E8F4F8', text: '#4A9BBF' },
  office: { bg: '#E8F4F8', text: '#4A9BBF' },
  title: { bg: '#F0EDE8', text: '#6B5E4F' },
  competence: { bg: '#E8F5EE', text: '#4A9B6F' },
  'experience:country': { bg: '#E8F0FA', text: '#4A90D9' },
  'experience:partner': { bg: '#FDEEF4', text: '#E74C8B' },
  'experience:client': { bg: '#EDF3ED', text: '#6B8E6B' },
  'experience:workType': { bg: '#EEEAFD', text: '#7B68EE' },
  'experience:industry': { bg: '#E6F7F0', text: '#2EAD7F' },
  'experience:practiceArea': { bg: '#F0EBF5', text: '#8B6DAF' },
};

// Props for the main SearchFilter component
export interface SearchFilterProps {
  facets?: UserSearchFacets;
  onChange: (params: UserSearchParams) => void;
  onSearchTermChange?: (term: string) => void;
}
